import { render, staticRenderFns } from "./docking.vue?vue&type=template&id=6db80bac&scoped=true"
import script from "./docking.vue?vue&type=script&lang=js"
export * from "./docking.vue?vue&type=script&lang=js"
import style0 from "./docking.vue?vue&type=style&index=0&id=6db80bac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db80bac",
  null
  
)

export default component.exports